import React, { useEffect, useRef, useState } from 'react'
import logo from '../../assets/img/logo.jpg'
import '../../assets/css/Dashboard.css'
import AOS from "aos";
import "aos/dist/aos.css";
import ManageBrand from './ManageBrand';
import DashboardSection from './DashboardSection';
import ManageModel from './ManageModel';
import ManageUser from './ManageUser';
import Profile from './Profile';
import ChangePassword from './ChangePassword';
import { useNavigate } from 'react-router-dom';
import Accessories from './Accessories';
import ManageVariation from './ManageVariation';
import Report from './Report';
import Workshops from './Workshops';
import Notification from './Notification';
import Leads from './Leads';
import Queue from './Queue';
import Managers from './Managers';
import ServiceBoys from './ServiceBoys';
import ManageBookings from './ManageBookings';

import Rejectcase from './Rejectcase';
import ServiceHistory from './ServiceHistory';
import Workshoplist from './Workshoplist';

import Bikestransfer from './Bikestransfer';
import Customerwisedetails from './Customerwisedetails';


import DeliveriesQueue from './DeliveriesQueue';
import DeliveriesHistory from './DeliveriesHistory';
import DeliveriesBoys from './DeliveriesBoys';
import axios from 'axios';
import AllServiceDone from './AllServiceDone';
import AllDeliveryBoys from './AllDeliveryBoys';
import AllManager from './AllManager';
import AllBookings from './AllBookings';
import BikeTransfer from './BikeTransfer';




function Dashboard() {
    // const [collapsed, setCollapsed] = useState(false);
    const [activeTab, setActiveTab] = useState(localStorage.getItem("activeTab") || "Dashboard");  // Get saved tab from localStorage
    const navigate = useNavigate()
    const [userRole, setUserRole] = useState(null);
    const [notificationCount, setNotificationCount] = useState(0);
    const [notifications, setNotifications] = useState();
    const dropdownRef = useRef(null);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(50); const [showNotification, setShowNotification] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const toggleDropdown = () => setShowNotification(!showNotification)
    const [showOptions, setShowOptions] = useState(false);

    const [username, setusername] = useState('');
    const closeBtnRef = useRef(null);


    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowNotification(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownRef]);

    const reportOptions = [
        { id: "Booking", label: "All Bookings" },
        { id: "Customerwisedetails", label: "Customer Details" },
        { id: "Service", label: "Delivery Boys" },
        { id: "BikeTransfer", label: "Bike Transfer" },
        // { id: "ManageUser", label: "Manage User" },
        // { id: "DeliveryBoy", label: "Delivery Boys" },
        // { id: "Manager", label: "Managers" },

    ];

    useEffect(() => {
        fetchNotificationCount();
        notification();

        ///window.history.pushState(null, "", window.location.href);

    }, []);



    useEffect(() => {
        // This function is called when the browser back button is pressed
        const handleBackEvent = (event) => {
            return false;
            // Your custom logic for the back event goes here
        };

        // Adding the event listener for the popstate event
        window.addEventListener('popstate', handleBackEvent);

        // Cleanup the event listener when the component is unmounted
        return () => {
            window.removeEventListener('popstate', handleBackEvent);
        };
    }, []);



    const fetchNotificationCount = async () => {
        const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
        const token = storedLoginData?.token;
        setusername(storedLoginData.name);
        try {
            const response = await axios.get(
                `https://devapi.bykit.in/api/admin/get-notifications?start=${(page - 1) * rowsPerPage
                }&length=${rowsPerPage}&?type=live`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (response.data.status === "RC200") {
                setNotifications(response.data.data.data)
            } else {
                setNotificationCount(0);
            }
        } catch (error) {
            console.error("Error fetching notification count:", error);
            setNotificationCount(0);
        }
    };


    // Store active tab in localStorage whenever it changes
    useEffect(() => {
        localStorage.setItem("activeTab", activeTab);
    }, [activeTab]);

    useEffect(() => {
        const storedData = localStorage.getItem("LoginData");
        if (storedData) {
            const parsedData = JSON.parse(storedData);
            setUserRole(parsedData.role);
        }
    }, []);

    const notification = async () => {
        const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
        const token = storedLoginData?.token;

        try {
            const response = await axios.get(
                "https://devapi.bykit.in/api/admin/check-notifications??type=live",
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            console.log('check notification', response.data.data)
            if (response.data.status === "RC200") {
                setNotificationCount(response.data.data.unread_notification || 0);
            } else {
                setNotificationCount(0);
            }
        } catch (error) {
            console.error("Error fetching notification count:", error);
            setNotificationCount(0);
        }
    };

    useEffect(() => {
        const storedData = localStorage.getItem("LoginData");
        if (storedData) {
            const parsedData = JSON.parse(storedData);
            setUserRole(parsedData.role); // Set role in state
        }
    }, []);


    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
        });
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('LoginData');
        localStorage.removeItem('activeTab');
        navigate('/');
    };

    const [darkMode, setDarkMode] = useState(() => {
        return localStorage.getItem("theme") === "dark";
    });

    // useEffect(() => {
    //     localStorage.setItem("theme", darkMode ? "dark" : "light");
    // }, [darkMode]);

    useEffect(() => {
        if (darkMode) {
            document.body.classList.add("dark-mode");
            localStorage.setItem("theme", "dark");
        } else {
            document.body.classList.remove("dark-mode");
            localStorage.setItem("theme", "light");
        }
    }, [darkMode]);


    // Close Dropdown When Clicking Outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // const closeOffcanvas = () => {
    //     setTimeout(() => {
    //         const closeBtn = document.querySelector('.offcanvas .btn-close');
    //         if (closeBtn) {
    //             console.log("Closing offcanvas...");
    //             closeBtn.click();
    //         } else {
    //             console.warn("Close button not found.");
    //         }
    //     }, 100);
    // };


    return (
        <div>
            <section className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 d-lg-block d-none'>
                        <div className='mt-3'>
                            <img src={logo} alt='' width='40%'></img>
                        </div>
                        <div><h4 className='menu'>MENU</h4></div>
                        <div className="mt-2">
                            <button
                                className={`menu_item ${activeTab === "Dashboard" ? "active_item" : ""}`}
                                onClick={() => setActiveTab("Dashboard")}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
                                    <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                        d="M2 5a2 2 0 0 1 2-2h6v18H4a2 2 0 0 1-2-2zm12-2h6a2 2 0 0 1 2 2v5h-8zm0 11h8v5a2 2 0 0 1-2 2h-6z" />
                                </svg>
                                Dashboard
                                {/* {!collapsed && <span className="ms-2">Dashboard</span>} */}
                            </button>
                        </div>
                        {userRole === 0 && (
                            <>
                                <div>
                                    <button className={`menu_item ${activeTab === 'ManageBrands' ? 'active_item' : ''}`} onClick={() => { setActiveTab('ManageBrands'); }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--oi" width="20px" height="20px" viewBox="0 0 8 8"><path fill="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M0 0v3h3V0zm4 0v1h4V0zm0 2v1h3V2zM0 4v3h3V4zm4 0v1h4V4zm0 2v1h3V6z"></path></svg>
                                        Manage Brands
                                        {/* {!collapsed && <span className="ms-2">Manage Brands</span>} */}
                                    </button>
                                </div>
                                <div className='mt-2'>
                                    <button className={`menu_item ${activeTab === 'ManageModel' ? 'active_item' : ''}`} onClick={() => setActiveTab('ManageModel')}>
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--fluent-mdl2" width="20px" height="20px" viewBox="0 0 2048 2048"><path fill="currentColor" d="M640 640h1408v128H640zm1408-384v128H640V256zM384 128v128H256v512h128v128H128V128zm256 1408h1408v128H640zm0-384h1408v128H640zm-256-128v128H256v512h128v128H128v-768z"></path></svg>
                                        Manage Model
                                    </button>
                                </div>

                                <div className='mt-2'>
                                    <button className={`menu_item ${activeTab === 'ModelVariations' ? 'active_item' : ''}`} onClick={() => setActiveTab('ModelVariations')}>
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--codicon" width="20px" height="20px" viewBox="0 0 16 16"><g fill="currentColor"><path d="M4 9h9v1H4zm0 3h7v1H4zm0-6h10v1H4zM1 3h11v1H1z"></path><path d="M4 4h1v9H4z"></path></g></svg>
                                        Model Variations
                                    </button>
                                </div>
                                {/* <div className='mt-2'>
                                    <button className={`menu_item ${activeTab === 'Accessories' ? 'active_item' : ''}`} onClick={() => setActiveTab('Accessories')}>
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--fluent" width="20px" height="20px" viewBox="0 0 24 24"><path fill="currentColor" d="M7.25 14a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zM6.5 9.25a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75m11.28-.47a.75.75 0 0 0-1.06-1.06l-1.47 1.47l-.47-.47a.75.75 0 1 0-1.06 1.06l1 1a.75.75 0 0 0 1.06 0zm0 4.44a.75.75 0 0 1 0 1.06l-2 2a.75.75 0 0 1-1.06 0l-1-1a.75.75 0 1 1 1.06-1.06l.47.47l1.47-1.47a.75.75 0 0 1 1.06 0M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5A3.25 3.25 0 0 0 6.25 21h11.5A3.25 3.25 0 0 0 21 17.75V6.25A3.25 3.25 0 0 0 17.75 3zM4.5 6.25c0-.966.784-1.75 1.75-1.75h11.5c.966 0 1.75.784 1.75 1.75v11.5a1.75 1.75 0 0 1-1.75 1.75H6.25a1.75 1.75 0 0 1-1.75-1.75z"></path></svg>
                                        Accessories</button>
                                </div> */}
                                <div className='mt-2'>
                                    <button className={`menu_item ${activeTab === 'Workshops' ? 'active_item' : ''}`}



                                        onClick={() => {
                                            setActiveTab(null); // Step 1: Deselect
                                            setTimeout(() => {
                                                setActiveTab('Workshops'); // Step 2: Reselect
                                            }, 0); // Can increase to 50ms if needed
                                        }}

                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--streamline" width="20px" height="20px" viewBox="0 0 14 14"><path fill="none" stroke="currentColor" strokeLinejoin="round" d="M1.5 8.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8.5M13 6H1a.5.5 0 0 1-.5-.5v-2l1.22-2.45a1 1 0 0 1 .9-.55h8.76a1 1 0 0 1 .9.55L13.5 3.5v2a.5.5 0 0 1-.5.5M8 8.5v5M1.5 10H8M.5 3.5h13"></path></svg>
                                        Workshops </button>
                                </div>
                                {/* Show report options */}
                                <div className='mt-2'>
                                    {/* Reports Button with Toggle */}
                                    <button
                                        className={`menu_item ${showOptions ? 'active_item' : ''}`}
                                        onClick={() => setShowOptions(!showOptions)}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--mdi" width="20px" height="20px" viewBox="0 0 24 24">
                                            <path fill="currentColor" d="M4 19v1h18v2H2V2h2v15c3 0 6-2 8.1-5.6c3-5 6.3-7.4 9.9-7.4v2c-2.8 0-5.5 2.1-8.1 6.5C11.3 16.6 7.7 19 4 19"></path>
                                        </svg>
                                        Reports
                                    </button>
                                </div>






                                {/* Show report options */}
                                {showOptions && (
                                    <div className="mt-2">
                                        {reportOptions.map((report) => (
                                            <button
                                                key={report.id}
                                                className={`menu_item ms-3 ${activeTab === report.id ? 'active_item' : ''}`}
                                                onClick={() => setActiveTab(report.id)}
                                            >
                                                {report.label}
                                            </button>
                                        ))}
                                    </div>
                                )}
                            </>
                        )}
                        {userRole === 1 && (
                            <>
                                <div className='mt-2'>
                                    <button className={`menu_item ${activeTab === 'Leads' ? 'active_item' : ''}`} onClick={() => setActiveTab('Leads')}>
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--oi" width="18px" height="18px" viewBox="0 0 8 8"><path fill="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M0 0v3h3V0zm4 0v1h4V0zm0 2v1h3V2zM0 4v3h3V4zm4 0v1h4V4zm0 2v1h3V6z"></path></svg>
                                        Leads </button>
                                </div>
                                <div className='mt-2'>
                                    <button className={`menu_item ${activeTab === 'Queue' ? 'active_item' : ''}`} onClick={() => { setActiveTab('Queue'); closeBtnRef.current?.click(); }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--mdi" width="18px" height="18px" viewBox="0 0 24 24"><path fill="currentColor" d="M6 6h12v2H6zm0 4.5h12v2H6zM6 15h12v2H6zm3 4h6l-3 3zM9 2h6l-3 3z"></path></svg>
                                        Queue </button>
                                </div>
                                {/* <div className='mt-2'>
                                    <button className={`menu_item ${activeTab === 'Managers' ? 'active_item' : ''}`} onClick={() => setActiveTab('Managers')}>
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--fluent-mdl2" width="18px" height="18px" viewBox="0 0 2048 2048"><path fill="currentColor" d="M2048 1792h-227q48 53 73 118t26 138h-128q0-53-20-99t-55-82t-81-55t-100-20q-53 0-99 20t-82 55t-55 81t-20 100h-128q0-53-20-99t-55-82t-81-55t-100-20q-53 0-99 20t-82 55t-55 81t-20 100H512q0-52 14-102t39-93t63-80t83-61q-34-35-52-81t-19-95q0-69 34-127t94-93v-292q0-30 13-57t38-45q-55-73-135-113t-172-41q-80 0-149 30t-122 82t-83 123t-30 149H0q0-73 20-141t57-129t91-108t118-81q-75-54-116-135t-42-174q0-79 30-149t82-122t122-83T512 0q79 0 149 30t122 82t83 123t30 149q0 93-41 174T738 694q68 34 123 85t94 117h357q31 0 54-9t43-24t41-31t46-31t58-23t78-10h288q27 0 50 10t40 27t28 41t10 50zM512 640q53 0 99-20t82-55t55-81t20-100q0-53-20-99t-55-82t-81-55t-100-20q-53 0-99 20t-82 55t-55 81t-20 100q0 53 20 99t55 82t81 55t100 20m384 1024q27 0 50-10t40-27t28-41t10-50q0-27-10-50t-27-40t-41-28t-50-10q-27 0-50 10t-40 27t-28 41t-10 50q0 27 10 50t27 40t41 28t50 10m640 0q27 0 50-10t40-27t28-41t10-50q0-27-10-50t-27-40t-41-28t-50-10q-27 0-50 10t-40 27t-28 41t-10 50q0 27 10 50t27 40t41 28t50 10m384-512h-288q-45 0-78-9t-58-24t-45-31t-41-31t-44-23t-54-10H896v256q53 0 99 20t82 55t55 81t20 100q0 49-18 95t-53 81q83 46 135 124q52-78 135-124q-34-35-52-81t-19-95q0-53 20-99t55-82t81-55t100-20q53 0 99 20t82 55t55 81t20 100q0 34-9 66t-27 62h164zm0-256h-288q-23 0-41 5t-34 13t-31 20t-32 26q16 14 31 25t32 20t34 14t41 5h288z"></path></svg>
                                        Managers </button>
                                </div>
                                <div className='mt-2'>
                                    <button className={`menu_item ${activeTab === 'ServiceBoys' ? 'active_item' : ''}`} onClick={() => setActiveTab('ServiceBoys')}>
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--mdi" width="18px" height="18px" viewBox="0 0 24 24"><path fill="currentColor" d="M16 9c0 5.33-8 5.33-8 0h2c0 2.67 4 2.67 4 0m6 9v3H4v-3c0-2.67 5.33-4 8-4s8 1.33 8 4m-1.9 0c0-.64-3.13-2.1-6.1-2.1S5.9 17.36 5.9 18v1.1h12.2M12.5 2c.28 0 .5.22.5.5v3h1V3a3.89 3.89 0 0 1 2.25 3.75s.7.14.75 1.25H7c0-1.11.75-1.25.75-1.25A3.89 3.89 0 0 1 10 3v2.5h1v-3c0-.28.22-.5.5-.5"></path></svg>
                                        Service Boys </button>
                                </div> */}
                                {/* <div className='mt-2'>
                                    <button className={`menu_item ${activeTab === 'ManageBookings' ? 'active_item' : ''}`} onClick={() => setActiveTab('ManageBookings')}>
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--carbon" width="18px" height="18px" viewBox="0 0 32 32"><path fill="currentColor" d="M28 13h-2v-2c0-2.8-2.2-5-5-5h-3V4h3c3.9 0 7 3.1 7 7zm-6 7h3v2h-3zm0 4h3v2h-3z"></path><path fill="currentColor" d="M27 30h-5v-2h5V18h-7v9c0 1.7-1.3 3-3 3s-3-1.3-3-3v-3h2v3c0 .6.4 1 1 1s1-.4 1-1V16h11v12c0 1.1-.9 2-2 2m-15-2h-1c-3.9 0-7-3.1-7-7v-4h2v4c0 2.8 2.2 5 5 5h1zm-1-18v2h3c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2.4l1.7 3l1.7-1l-2.3-4H4V4h10v6z"></path></svg>
                                        Manage Bookings </button>
                                </div> */}
                                <div className='mt-2'>
                                    <button className={`menu_item ${activeTab === 'ServiceHistory' ? 'active_item' : ''}`} onClick={() => setActiveTab('ServiceHistory')}>
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--icon-park-outline" width="18px" height="18px" viewBox="0 0 48 48"><g fill="none" stroke="currentColor" stroke-width="4"><path stroke-linecap="round" stroke-linejoin="round" d="M42 24V9a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v30a3 3 0 0 0 3 3h15"></path><circle cx="32" cy="32" r="6"></circle><path stroke-linecap="round" stroke-linejoin="round" d="m37 36l5 4M14 16h20m-20 8h8"></path></g></svg>
                                        Service History </button>
                                </div>

                                <div className='mt-2'>
                                    <button className={`menu_item ${activeTab === 'Rejectcase' ? 'active_item' : ''}`} onClick={() => setActiveTab('Rejectcase')}>
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--icon-park-outline" width="18px" height="18px" viewBox="0 0 48 48"><g fill="none" stroke="currentColor" stroke-width="4"><path stroke-linecap="round" stroke-linejoin="round" d="M42 24V9a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v30a3 3 0 0 0 3 3h15"></path><circle cx="32" cy="32" r="6"></circle><path stroke-linecap="round" stroke-linejoin="round" d="m37 36l5 4M14 16h20m-20 8h8"></path></g></svg>
                                        Rejected Cases </button>
                                </div>

                                <div className='mt-2'>
                                    <button className={`menu_item ${activeTab === 'Report' ? 'active_item' : ''}`} onClick={() => setActiveTab('Report')}>
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--mdi" width="20px" height="20px" viewBox="0 0 24 24">
                                            <path fill="currentColor" d="M4 19v1h18v2H2V2h2v15c3 0 6-2 8.1-5.6c3-5 6.3-7.4 9.9-7.4v2c-2.8 0-5.5 2.1-8.1 6.5C11.3 16.6 7.7 19 4 19"></path>
                                        </svg>Reports </button>
                                </div>

                                {/* <div className='mt-2'>
                                    <button className={`menu_item ${activeTab === 'Customerwisedetails' ? 'active_item' : ''}`} onClick={() => setActiveTab('Customerwisedetails')}>
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--mdi" width="20px" height="20px" viewBox="0 0 24 24">
                                            <path fill="currentColor" d="M4 19v1h18v2H2V2h2v15c3 0 6-2 8.1-5.6c3-5 6.3-7.4 9.9-7.4v2c-2.8 0-5.5 2.1-8.1 6.5C11.3 16.6 7.7 19 4 19"></path>
                                        </svg>Customer Wise Details </button>
                                </div> */}


                            </>
                        )}

                        {userRole === 4 && (
                            <>
                                <div className='mt-2'>
                                    <button className={`menu_item ${activeTab === 'DeliveriesQueue' ? 'active_item' : ''}`} onClick={() => setActiveTab('DeliveriesQueue')}>
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--icon-park-outline" width="20px" height="20px" viewBox="0 0 48 48"><g fill="none" stroke="currentColor" stroke-width="4"><path stroke-linecap="round" stroke-linejoin="round" d="M42 24V9a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v30a3 3 0 0 0 3 3h15"></path><circle cx="32" cy="32" r="6"></circle><path stroke-linecap="round" stroke-linejoin="round" d="m37 36l5 4M14 16h20m-20 8h8"></path></g></svg>
                                        Deliveries Queue </button>
                                </div>
                                <div className='mt-2'>
                                    <button className={`menu_item ${activeTab === 'DeliveriesHistory' ? 'active_item' : ''}`} onClick={() => setActiveTab('DeliveriesHistory')}>
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--icon-park-outline" width="20px" height="20px" viewBox="0 0 48 48"><g fill="none" stroke="currentColor" stroke-width="4"><path stroke-linecap="round" stroke-linejoin="round" d="M42 24V9a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v30a3 3 0 0 0 3 3h15"></path><circle cx="32" cy="32" r="6"></circle><path stroke-linecap="round" stroke-linejoin="round" d="m37 36l5 4M14 16h20m-20 8h8"></path></g></svg>
                                        Deliveries History </button>
                                </div>

                                <div className='mt-2'>
                                    <button
                                        className={`menu_item ${activeTab === 'DeliveriesBoys' ? 'active_item' : ''}`}
                                        onClick={() => {
                                            setActiveTab(null); // Step 1: Deselect
                                            setTimeout(() => {
                                                setActiveTab('DeliveriesBoys'); // Step 2: Reselect
                                            }, 0); // Can increase to 50ms if needed
                                        }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--mage" width="20px" height="20px" viewBox="0 0 24 24">
                                            <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M17.928 19.634h2.138a1.165 1.165 0 0 0 1.116-1.555a6.85 6.85 0 0 0-6.117-3.95m0-2.759a3.664 3.664 0 0 0 3.665-3.664a3.664 3.664 0 0 0-3.665-3.674m-1.04 16.795a1.908 1.908 0 0 0 1.537-3.035a8.03 8.03 0 0 0-6.222-3.196a8.03 8.03 0 0 0-6.222 3.197a1.909 1.909 0 0 0 1.536 3.034zM9.34 11.485a4.16 4.16 0 0 0 4.15-4.161a4.151 4.151 0 0 0-8.302 0a4.16 4.16 0 0 0 4.151 4.16" />
                                        </svg>
                                        Delivery Boys
                                    </button>
                                </div>

                                <div className='mt-2'>
                                    <button className={`menu_item ${activeTab === 'Workshoplist' ? 'active_item' : ''}`}
                                        onClick={() => {
                                            setActiveTab(null); // Step 1: Deselect
                                            setTimeout(() => {
                                                setActiveTab('Workshoplist'); // Step 2: Reselect
                                            }, 0); // Can increase to 50ms if needed
                                        }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--icon-park-outline" width="20px" height="20px" viewBox="0 0 48 48"><g fill="none" stroke="currentColor" stroke-width="4"><path stroke-linecap="round" stroke-linejoin="round" d="M42 24V9a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v30a3 3 0 0 0 3 3h15"></path><circle cx="32" cy="32" r="6"></circle><path stroke-linecap="round" stroke-linejoin="round" d="m37 36l5 4M14 16h20m-20 8h8"></path></g></svg>Godown</button>
                                </div>

                                <div className='mt-2'>
                                    <button className={`menu_item ${activeTab === 'Bikestransfer' ? 'active_item' : ''}`}
                                        onClick={() => {
                                            setActiveTab(null); // Step 1: Deselect
                                            setTimeout(() => {
                                                setActiveTab('Bikestransfer'); // Step 2: Reselect
                                            }, 0); // Can increase to 50ms if needed
                                        }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--icon-park-outline" width="20px" height="20px" viewBox="0 0 48 48"><g fill="none" stroke="currentColor" stroke-width="4"><path stroke-linecap="round" stroke-linejoin="round" d="M42 24V9a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v30a3 3 0 0 0 3 3h15"></path><circle cx="32" cy="32" r="6"></circle><path stroke-linecap="round" stroke-linejoin="round" d="m37 36l5 4M14 16h20m-20 8h8"></path></g></svg>Bikes Transfer</button>
                                </div>






                            </>
                        )}

                        <div className='mt-2'>
                            <button className={`menu_item ${activeTab === 'Logout' ? 'active_item' : ''}`} onClick={handleLogout}>
                                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--hugeicons" width="20px" height="20px" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15 17.625c-.074 1.852-1.617 3.424-3.684 3.374c-.481-.012-1.076-.18-2.265-.515c-2.861-.807-5.345-2.164-5.941-5.203C3 14.724 3 14.095 3 12.837v-1.674c0-1.257 0-1.886.11-2.445c.596-3.038 3.08-4.395 5.941-5.202c1.19-.335 1.784-.503 2.265-.515c2.067-.05 3.61 1.522 3.684 3.374M21 12H10m11 0c0-.7-1.994-2.008-2.5-2.5M21 12c0 .7-1.994 2.008-2.5 2.5" color="currentColor"></path></svg>
                                Logout </button>
                        </div>
                    </div>
                    <div className='col-lg-10 col-md-12 col-sm-12 col-12'>
                        <div className='menu_bar'>
                            <div className="d-lg-none d-block offcanvas_btn">
                                <button
                                    className="btn"
                                    data-bs-toggle="offcanvas"
                                    data-bs-target="#offcanvasMenu"
                                    aria-controls="offcanvasMenu"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            fill="none"
                                            stroke="currentColor"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M4 6h16M4 12h16m-7 6h7"
                                        />
                                    </svg>
                                </button>
                            </div>
                            <div className='menu_barS'>
                                <svg xmlns="http://www.w3.org/2000/svg" onClick={() => setDarkMode(!darkMode)} aria-hidden="true" role="img" className="iconify iconify--heroicons-outline icon_bg p-1 me-3" width="28px" height="28px" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 0 1 8.646 3.646A9.003 9.003 0 0 0 12 21a9 9 0 0 0 8.354-5.646"></path></svg>

                                <div className={`notification-container me-3  ${showNotification ? 'active' : ''}`} onClick={toggleDropdown} ref={dropdownRef}>

                                    <svg xmlns="http://www.w3.org/2000/svg" className="bell-icon icon_bg p-1" viewBox="0 0 24 24">
                                        <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.03 2.03 0 0 1 18 14.158V11a6 6 0 0 0-4-5.659V5a2 2 0 1 0-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 1 1-6 0v-1m6 0H9"></path>
                                    </svg>
                                    <span className="notification-badge">{notificationCount}</span>
                                </div>
                                {/* ----------------------------------------------------------------------------------------------------------------------------- */}

                                <div className="notification-wrapper" data-aos="fade-down-left" ref={dropdownRef} >
                                    {showNotification && (
                                        <div className="notification-dropdown">
                                            <div className="dropdown-header">
                                                <span style={{ color: '#1E293B', fontSize: '15px' }}>Notifications</span>
                                                <button className="view-all-btn" onClick={() => {
                                                    setActiveTab('Notification');
                                                    setShowNotification(false);
                                                }}>View all</button>
                                            </div>

                                            {/* Notification List */}
                                            <ul className="notification-list">
                                                {notifications.length > 0 ? (
                                                    notifications.slice(0, 5).map((item, index) => (
                                                        <li key={index} className="notification-item p-2">
                                                            <div className="notification-content">
                                                                <p style={{ fontWeight: '700', color: '#475569CC', fontSize: '14px' }}>
                                                                    {item.title}
                                                                </p>
                                                                <p style={{ color: '#475569' }}>{item.message}</p>
                                                            </div>
                                                            {!item.read && <span className="notification-dot"></span>}
                                                        </li>
                                                    ))
                                                ) : (
                                                    <li className="no-notifications">No new notifications</li>
                                                )}
                                            </ul>
                                        </div>
                                    )}
                                </div>

                                <div class="dropdown">
                                    <button type="button" class="btn dropdown-toggle" data-bs-toggle="dropdown">
                                        {userRole === 0 && "ByKit Admin"}
                                        {userRole === 1 && username}
                                        {userRole === 4 && "Delivery Admin"}
                                    </button>
                                    <ul class="dropdown-menu">
                                        <div className=''>
                                            <button className={`menu_item1 ${activeTab === 'Profile' ? '' : ''}`} onClick={() => setActiveTab('Profile')}>
                                                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--heroicons-outline" width="20px" height="20px" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 1 1-8 0a4 4 0 0 1 8 0m-4 7a7 7 0 0 0-7 7h14a7 7 0 0 0-7-7"></path></svg>
                                                Profile</button>
                                        </div>
                                        <div className=''>
                                            <button className={`menu_item1 ${activeTab === 'ChangePassword' ? '' : ''}`} onClick={() => setActiveTab('ChangePassword')}>
                                                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--heroicons-outline" width="20px" height="20px" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 1 1-8 0a4 4 0 0 1 8 0m-4 7a7 7 0 0 0-7 7h14a7 7 0 0 0-7-7"></path></svg>
                                                Change Password</button>
                                        </div>
                                        <div className=''>
                                            <button className={`menu_item1 ${activeTab === 'Logout' ? '' : ''}`} onClick={handleLogout}>
                                                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--heroicons-outline" width="20px" height="20px" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h7a3 3 0 0 1 3 3v1"></path></svg>
                                                Logout </button>
                                        </div>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <hr className="p-0 m-0" />
                        <div className={`dashboard_box ${darkMode ? "dark-mode" : ""}`} style={{ backgroundColor: darkMode ? "#1E293B" : "#F1F5F9" }}>
                            {activeTab === 'Dashboard' &&
                                <div data-aos="fade-up">
                                    <DashboardSection></DashboardSection>
                                </div>
                            }
                            {activeTab === 'ManageBrands' &&
                                <div data-aos="fade-up">
                                    <ManageBrand darkMode={darkMode}></ManageBrand>
                                </div>
                            }
                            {activeTab === 'ManageModel' &&
                                <div data-aos="fade-up">
                                    <ManageModel></ManageModel>
                                </div>
                            }
                            {activeTab === 'ManageUser' &&
                                <div data-aos="fade-up">
                                    <ManageUser></ManageUser>
                                </div>
                            }
                            {activeTab === 'ModelVariations' &&
                                <div data-aos="fade-up">
                                    <ManageVariation></ManageVariation>
                                </div>
                            }
                            {/* {activeTab === 'Accessories' &&
                                <div data-aos="fade-up">
                                    <Accessories></Accessories>
                                </div>
                            } */}
                            {activeTab === 'Workshops' &&
                                <div data-aos="fade-up">
                                    <Workshops></Workshops>
                                </div>
                            }

                            {activeTab === 'Bikestransfer' &&
                                <div data-aos="fade-up">
                                    <Bikestransfer></Bikestransfer>
                                </div>
                            }

                            {activeTab === 'Report' &&
                                <div data-aos="fade-up">
                                    <Report></Report>
                                </div>
                            }

                            {activeTab === 'Customerwisedetails' &&
                                <div data-aos="fade-up">
                                    <Customerwisedetails></Customerwisedetails>
                                </div>
                            }

                            {activeTab === 'Profile' &&
                                <div data-aos="fade-up">
                                    <Profile></Profile>
                                </div>
                            }
                            {activeTab === 'ChangePassword' &&
                                <div data-aos="fade-up">
                                    <ChangePassword></ChangePassword>
                                </div>
                            }
                            {
                                activeTab === 'Leads' &&
                                <div data-aos="fade-up">
                                    <Leads></Leads>
                                </div>
                            }
                            {
                                activeTab === 'Queue' &&
                                <div data-aos="fade-up">
                                    <Queue></Queue>
                                </div>
                            }

                            {/* {
                                activeTab === 'Managers' &&
                                <div data-aos="fade-up">
                                    <Managers></Managers>
                                </div>
                            }
                            {
                                activeTab === 'ServiceBoys' &&
                                <div data-aos="fade-up">
                                    <ServiceBoys></ServiceBoys>
                                </div>
                            } */}

                            {
                                activeTab === 'ManageBookings' &&
                                <div data-aos="fade-up">
                                    <ManageBookings></ManageBookings>
                                </div>
                            }
                            {
                                activeTab === 'ServiceHistory' &&
                                <div data-aos="fade-up">
                                    <ServiceHistory></ServiceHistory>
                                </div>
                            }

                            {
                                activeTab === 'Rejectcase' &&
                                <div data-aos="fade-up">
                                    <Rejectcase></Rejectcase>
                                </div>
                            }

                            {
                                activeTab === 'DeliveriesQueue' &&
                                <div data-aos="fade-up">
                                    <DeliveriesQueue></DeliveriesQueue>
                                </div>
                            }
                            {
                                activeTab === 'DeliveriesHistory' &&
                                <div data-aos="fade-up">
                                    <DeliveriesHistory />
                                </div>
                            }
                            {
                                activeTab === 'DeliveriesBoys' &&
                                <div data-aos="fade-up">
                                    <DeliveriesBoys></DeliveriesBoys>
                                </div>
                            }

                            {
                                activeTab === 'Workshoplist' &&
                                <div data-aos="fade-up">
                                    <Workshoplist></Workshoplist>
                                </div>
                            }

                            {
                                activeTab === 'Notification' &&
                                <div data-aos="fade-up">
                                    <Notification setNotificationCount={setNotificationCount} ></Notification>
                                </div>
                            }

                            {activeTab === "Service" && <AllServiceDone></AllServiceDone>}
                            {activeTab === "BikeTransfer" && <BikeTransfer></BikeTransfer>}
                            {activeTab === "DeliveryBoy" && <AllDeliveryBoys></AllDeliveryBoys>}
                            {activeTab === "Manager" && <AllManager></AllManager>}
                            {activeTab === "Booking" && <AllBookings></AllBookings>}

                        </div>

                        <hr className='p-0 m-0'></hr>
                        <div>
                            <div type="submit" className="dash-footer">&copy; {new Date().getFullYear()} ByKit, All rights reserved.</div>
                        </div>
                    </div>

                    {/* <div className={`content-area ${collapsed ? "expanded" : ""} col-lg-10 col-md-10 col-sm-12 col-12`}>
                    {activeTab === "ManageBrands" && (
                        <div>
                            <h3>Manage Brands</h3>
                        </div>
                    )}
                </div> */}

                </div>
            </section>
            <div
                className="offcanvas offcanvas-start"
                tabIndex="-1"
                id="offcanvasMenu"
                aria-labelledby="offcanvasMenuLabel"
            >
                <div className="offcanvas-header">
                    <div className="">
                        <img src={logo} alt="" width="40%" />
                    </div>
                    <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" ref={closeBtnRef}></button>
                </div>

                <div className="offcanvas-body">
                    <div>
                        <h4 className="menu mt-0">MENU</h4>
                    </div>




                    {userRole === 0 && (
                        <>
                            <div>
                                <button className={`menu_item ${activeTab === "Dashboard" ? "active_item" : ""}`}
                                    onClick={() => { setActiveTab("Dashboard"); closeBtnRef.current?.click(); }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--oi" width="20px" height="20px" viewBox="0 0 8 8"><path fill="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M0 0v3h3V0zm4 0v1h4V0zm0 2v1h3V2zM0 4v3h3V4zm4 0v1h4V4zm0 2v1h3V6z"></path></svg>
                                    Dashboard
                                    {/* {!collapsed && <span className="ms-2">Manage Brands</span>} */}
                                </button>
                            </div>
                            <div>
                                <button className={`menu_item ${activeTab === 'ManageBrands' ? 'active_item' : ''}`} onClick={() => { setActiveTab('ManageBrands'); closeBtnRef.current?.click(); }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--oi" width="20px" height="20px" viewBox="0 0 8 8"><path fill="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M0 0v3h3V0zm4 0v1h4V0zm0 2v1h3V2zM0 4v3h3V4zm4 0v1h4V4zm0 2v1h3V6z"></path></svg>
                                    Manage Brands
                                    {/* {!collapsed && <span className="ms-2">Manage Brands</span>} */}
                                </button>
                            </div>
                            <div className='mt-2'>
                                <button className={`menu_item ${activeTab === 'ManageModel' ? 'active_item' : ''}`} onClick={() => { setActiveTab('ManageModel'); closeBtnRef.current?.click(); }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--fluent-mdl2" width="20px" height="20px" viewBox="0 0 2048 2048"><path fill="currentColor" d="M640 640h1408v128H640zm1408-384v128H640V256zM384 128v128H256v512h128v128H128V128zm256 1408h1408v128H640zm0-384h1408v128H640zm-256-128v128H256v512h128v128H128v-768z"></path></svg>
                                    Manage Model
                                </button>
                            </div>

                            <div className='mt-2'>
                                <button className={`menu_item ${activeTab === 'ModelVariations' ? 'active_item' : ''}`} onClick={() => { setActiveTab('ModelVariations'); closeBtnRef.current?.click(); }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--codicon" width="20px" height="20px" viewBox="0 0 16 16"><g fill="currentColor"><path d="M4 9h9v1H4zm0 3h7v1H4zm0-6h10v1H4zM1 3h11v1H1z"></path><path d="M4 4h1v9H4z"></path></g></svg>
                                    Model Variations
                                </button>
                            </div>
                            {/* <div className='mt-2'>
                                    <button className={`menu_item ${activeTab === 'Accessories' ? 'active_item' : ''}`} onClick={() => setActiveTab('Accessories')}>
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--fluent" width="20px" height="20px" viewBox="0 0 24 24"><path fill="currentColor" d="M7.25 14a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zM6.5 9.25a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75m11.28-.47a.75.75 0 0 0-1.06-1.06l-1.47 1.47l-.47-.47a.75.75 0 1 0-1.06 1.06l1 1a.75.75 0 0 0 1.06 0zm0 4.44a.75.75 0 0 1 0 1.06l-2 2a.75.75 0 0 1-1.06 0l-1-1a.75.75 0 1 1 1.06-1.06l.47.47l1.47-1.47a.75.75 0 0 1 1.06 0M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5A3.25 3.25 0 0 0 6.25 21h11.5A3.25 3.25 0 0 0 21 17.75V6.25A3.25 3.25 0 0 0 17.75 3zM4.5 6.25c0-.966.784-1.75 1.75-1.75h11.5c.966 0 1.75.784 1.75 1.75v11.5a1.75 1.75 0 0 1-1.75 1.75H6.25a1.75 1.75 0 0 1-1.75-1.75z"></path></svg>
                                        Accessories</button>
                                </div> */}
                            <div className='mt-2'>
                                <button className={`menu_item ${activeTab === 'Workshops' ? 'active_item' : ''}`}


                                    onClick={() => {
                                        setActiveTab(null); // Step 1: Deselect
                                        setTimeout(() => {
                                            setActiveTab('Workshops'); // Step 2: Reselect
                                            closeBtnRef.current?.click();
                                        }, 0); // Can increase to 50ms if needed
                                    }}


                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--streamline" width="20px" height="20px" viewBox="0 0 14 14"><path fill="none" stroke="currentColor" strokeLinejoin="round" d="M1.5 8.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8.5M13 6H1a.5.5 0 0 1-.5-.5v-2l1.22-2.45a1 1 0 0 1 .9-.55h8.76a1 1 0 0 1 .9.55L13.5 3.5v2a.5.5 0 0 1-.5.5M8 8.5v5M1.5 10H8M.5 3.5h13"></path></svg>
                                    Workshops </button>
                            </div>
                            {/* Show report options */}
                            <div className='mt-2'>
                                {/* Reports Button with Toggle */}
                                <button
                                    className={`menu_item ${showOptions ? 'active_item' : ''}`}
                                    onClick={() => { setShowOptions(!showOptions); }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--mdi" width="20px" height="20px" viewBox="0 0 24 24">
                                        <path fill="currentColor" d="M4 19v1h18v2H2V2h2v15c3 0 6-2 8.1-5.6c3-5 6.3-7.4 9.9-7.4v2c-2.8 0-5.5 2.1-8.1 6.5C11.3 16.6 7.7 19 4 19"></path>
                                    </svg>
                                    Reports
                                </button>
                            </div>






                            {/* Show report options */}
                            {showOptions && (
                                <div className="mt-2">
                                    {reportOptions.map((report) => (
                                        <button
                                            key={report.id}
                                            className={`menu_item ms-3 ${activeTab === report.id ? 'active_item' : ''}`}
                                            onClick={() => { setActiveTab(report.id); closeBtnRef.current?.click(); }}
                                        >
                                            {report.label}
                                        </button>
                                    ))}
                                </div>
                            )}


                            <div className='mt-2'>
                                <button className={`menu_item ${activeTab === 'Logout' ? '' : ''}`} onClick={handleLogout}>
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--heroicons-outline" width="20px" height="20px" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h7a3 3 0 0 1 3 3v1"></path></svg>
                                    Logout </button>
                            </div>
                        </>
                    )}
                    {userRole === 1 && (
                        <>
                            <div>
                                <button className={`menu_item ${activeTab === "Dashboard" ? "active_item" : ""}`}
                                    onClick={() => { setActiveTab("Dashboard"); closeBtnRef.current?.click(); }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--oi" width="20px" height="20px" viewBox="0 0 8 8"><path fill="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M0 0v3h3V0zm4 0v1h4V0zm0 2v1h3V2zM0 4v3h3V4zm4 0v1h4V4zm0 2v1h3V6z"></path></svg>
                                    Dashboard

                                </button>
                            </div>
                            <div className='mt-2'>
                                <button className={`menu_item ${activeTab === 'Leads' ? 'active_item' : ''}`} onClick={() => { setActiveTab('Leads'); closeBtnRef.current?.click(); }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--oi" width="18px" height="18px" viewBox="0 0 8 8"><path fill="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M0 0v3h3V0zm4 0v1h4V0zm0 2v1h3V2zM0 4v3h3V4zm4 0v1h4V4zm0 2v1h3V6z"></path></svg>
                                    Leads </button>
                            </div>
                            <div className='mt-2'>
                                <button className={`menu_item ${activeTab === 'Queue' ? 'active_item' : ''}`} onClick={() => { setActiveTab('Queue'); closeBtnRef.current?.click(); }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--mdi" width="18px" height="18px" viewBox="0 0 24 24"><path fill="currentColor" d="M6 6h12v2H6zm0 4.5h12v2H6zM6 15h12v2H6zm3 4h6l-3 3zM9 2h6l-3 3z"></path></svg>
                                    Queue</button>
                            </div>
                            {/* <div className='mt-2'>
                                    <button className={`menu_item ${activeTab === 'Managers' ? 'active_item' : ''}`} onClick={() => setActiveTab('Managers')}>
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--fluent-mdl2" width="18px" height="18px" viewBox="0 0 2048 2048"><path fill="currentColor" d="M2048 1792h-227q48 53 73 118t26 138h-128q0-53-20-99t-55-82t-81-55t-100-20q-53 0-99 20t-82 55t-55 81t-20 100h-128q0-53-20-99t-55-82t-81-55t-100-20q-53 0-99 20t-82 55t-55 81t-20 100H512q0-52 14-102t39-93t63-80t83-61q-34-35-52-81t-19-95q0-69 34-127t94-93v-292q0-30 13-57t38-45q-55-73-135-113t-172-41q-80 0-149 30t-122 82t-83 123t-30 149H0q0-73 20-141t57-129t91-108t118-81q-75-54-116-135t-42-174q0-79 30-149t82-122t122-83T512 0q79 0 149 30t122 82t83 123t30 149q0 93-41 174T738 694q68 34 123 85t94 117h357q31 0 54-9t43-24t41-31t46-31t58-23t78-10h288q27 0 50 10t40 27t28 41t10 50zM512 640q53 0 99-20t82-55t55-81t20-100q0-53-20-99t-55-82t-81-55t-100-20q-53 0-99 20t-82 55t-55 81t-20 100q0 53 20 99t55 82t81 55t100 20m384 1024q27 0 50-10t40-27t28-41t10-50q0-27-10-50t-27-40t-41-28t-50-10q-27 0-50 10t-40 27t-28 41t-10 50q0 27 10 50t27 40t41 28t50 10m640 0q27 0 50-10t40-27t28-41t10-50q0-27-10-50t-27-40t-41-28t-50-10q-27 0-50 10t-40 27t-28 41t-10 50q0 27 10 50t27 40t41 28t50 10m384-512h-288q-45 0-78-9t-58-24t-45-31t-41-31t-44-23t-54-10H896v256q53 0 99 20t82 55t55 81t20 100q0 49-18 95t-53 81q83 46 135 124q52-78 135-124q-34-35-52-81t-19-95q0-53 20-99t55-82t81-55t100-20q53 0 99 20t82 55t55 81t20 100q0 34-9 66t-27 62h164zm0-256h-288q-23 0-41 5t-34 13t-31 20t-32 26q16 14 31 25t32 20t34 14t41 5h288z"></path></svg>
                                        Managers </button>
                                </div>
                                <div className='mt-2'>
                                    <button className={`menu_item ${activeTab === 'ServiceBoys' ? 'active_item' : ''}`} onClick={() => setActiveTab('ServiceBoys')}>
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--mdi" width="18px" height="18px" viewBox="0 0 24 24"><path fill="currentColor" d="M16 9c0 5.33-8 5.33-8 0h2c0 2.67 4 2.67 4 0m6 9v3H4v-3c0-2.67 5.33-4 8-4s8 1.33 8 4m-1.9 0c0-.64-3.13-2.1-6.1-2.1S5.9 17.36 5.9 18v1.1h12.2M12.5 2c.28 0 .5.22.5.5v3h1V3a3.89 3.89 0 0 1 2.25 3.75s.7.14.75 1.25H7c0-1.11.75-1.25.75-1.25A3.89 3.89 0 0 1 10 3v2.5h1v-3c0-.28.22-.5.5-.5"></path></svg>
                                        Service Boys </button>
                                </div> */}
                            {/* <div className='mt-2'>
                                    <button className={`menu_item ${activeTab === 'ManageBookings' ? 'active_item' : ''}`} onClick={() => setActiveTab('ManageBookings')}>
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--carbon" width="18px" height="18px" viewBox="0 0 32 32"><path fill="currentColor" d="M28 13h-2v-2c0-2.8-2.2-5-5-5h-3V4h3c3.9 0 7 3.1 7 7zm-6 7h3v2h-3zm0 4h3v2h-3z"></path><path fill="currentColor" d="M27 30h-5v-2h5V18h-7v9c0 1.7-1.3 3-3 3s-3-1.3-3-3v-3h2v3c0 .6.4 1 1 1s1-.4 1-1V16h11v12c0 1.1-.9 2-2 2m-15-2h-1c-3.9 0-7-3.1-7-7v-4h2v4c0 2.8 2.2 5 5 5h1zm-1-18v2h3c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2.4l1.7 3l1.7-1l-2.3-4H4V4h10v6z"></path></svg>
                                        Manage Bookings </button>
                                </div> */}
                            <div className='mt-2'>
                                <button className={`menu_item ${activeTab === 'ServiceHistory' ? 'active_item' : ''}`} onClick={() => { setActiveTab('ServiceHistory'); closeBtnRef.current?.click(); }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--icon-park-outline" width="18px" height="18px" viewBox="0 0 48 48"><g fill="none" stroke="currentColor" stroke-width="4"><path stroke-linecap="round" stroke-linejoin="round" d="M42 24V9a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v30a3 3 0 0 0 3 3h15"></path><circle cx="32" cy="32" r="6"></circle><path stroke-linecap="round" stroke-linejoin="round" d="m37 36l5 4M14 16h20m-20 8h8"></path></g></svg>
                                    Service History </button>
                            </div>

                            <div className='mt-2'>
                                <button className={`menu_item ${activeTab === 'Rejectcase' ? 'active_item' : ''}`} onClick={() => { setActiveTab('Rejectcase'); closeBtnRef.current?.click(); }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--icon-park-outline" width="18px" height="18px" viewBox="0 0 48 48"><g fill="none" stroke="currentColor" stroke-width="4"><path stroke-linecap="round" stroke-linejoin="round" d="M42 24V9a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v30a3 3 0 0 0 3 3h15"></path><circle cx="32" cy="32" r="6"></circle><path stroke-linecap="round" stroke-linejoin="round" d="m37 36l5 4M14 16h20m-20 8h8"></path></g></svg>
                                    Rejected Case </button>
                            </div>

                            <div className='mt-2'>
                                <button className={`menu_item ${activeTab === 'Report' ? 'active_item' : ''}`} onClick={() => { setActiveTab('Report'); closeBtnRef.current?.click(); }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--mdi" width="20px" height="20px" viewBox="0 0 24 24">
                                        <path fill="currentColor" d="M4 19v1h18v2H2V2h2v15c3 0 6-2 8.1-5.6c3-5 6.3-7.4 9.9-7.4v2c-2.8 0-5.5 2.1-8.1 6.5C11.3 16.6 7.7 19 4 19"></path>
                                    </svg>Reports </button>
                            </div>

                            {/* <div className='mt-2'>
                                    <button className={`menu_item ${activeTab === 'Customerwisedetails' ? 'active_item' : ''}`} onClick={() => setActiveTab('Customerwisedetails')}>
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--mdi" width="20px" height="20px" viewBox="0 0 24 24">
                                            <path fill="currentColor" d="M4 19v1h18v2H2V2h2v15c3 0 6-2 8.1-5.6c3-5 6.3-7.4 9.9-7.4v2c-2.8 0-5.5 2.1-8.1 6.5C11.3 16.6 7.7 19 4 19"></path>
                                        </svg>Customer Wise Details </button>
                                </div> */}

                            <div className='mt-2'>
                                <button className={`menu_item ${activeTab === 'Logout' ? '' : ''}`} onClick={handleLogout}>
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--heroicons-outline" width="20px" height="20px" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h7a3 3 0 0 1 3 3v1"></path></svg>
                                    Logout </button>
                            </div>
                        </>
                    )}

                    {userRole === 4 && (
                        <>
                            <div>
                                <button className={`menu_item ${activeTab === "Dashboard" ? "active_item" : ""}`}
                                    onClick={() => { setActiveTab("Dashboard"); closeBtnRef.current?.click(); }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--oi" width="20px" height="20px" viewBox="0 0 8 8"><path fill="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M0 0v3h3V0zm4 0v1h4V0zm0 2v1h3V2zM0 4v3h3V4zm4 0v1h4V4zm0 2v1h3V6z"></path></svg>
                                    Dashboard

                                </button>
                            </div>
                            <div className='mt-2'>
                                <button className={`menu_item ${activeTab === 'DeliveriesQueue' ? 'active_item' : ''}`} onClick={() => { setActiveTab('DeliveriesQueue'); closeBtnRef.current?.click(); }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--icon-park-outline" width="20px" height="20px" viewBox="0 0 48 48"><g fill="none" stroke="currentColor" stroke-width="4"><path stroke-linecap="round" stroke-linejoin="round" d="M42 24V9a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v30a3 3 0 0 0 3 3h15"></path><circle cx="32" cy="32" r="6"></circle><path stroke-linecap="round" stroke-linejoin="round" d="m37 36l5 4M14 16h20m-20 8h8"></path></g></svg>
                                    Deliveries Queue </button>
                            </div>
                            <div className='mt-2'>
                                <button className={`menu_item ${activeTab === 'DeliveriesHistory' ? 'active_item' : ''}`} onClick={() => { setActiveTab('DeliveriesHistory'); closeBtnRef.current?.click(); }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--icon-park-outline" width="20px" height="20px" viewBox="0 0 48 48"><g fill="none" stroke="currentColor" stroke-width="4"><path stroke-linecap="round" stroke-linejoin="round" d="M42 24V9a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v30a3 3 0 0 0 3 3h15"></path><circle cx="32" cy="32" r="6"></circle><path stroke-linecap="round" stroke-linejoin="round" d="m37 36l5 4M14 16h20m-20 8h8"></path></g></svg>
                                    Deliveries History </button>
                            </div>

                            <div className='mt-2'>
                                <button
                                    className={`menu_item ${activeTab === 'DeliveriesBoys' ? 'active_item' : ''}`}
                                    onClick={() => {
                                        setActiveTab(null); // Step 1: Deselect
                                        setTimeout(() => {
                                            setActiveTab('DeliveriesBoys'); // Step 2: Reselect
                                            closeBtnRef.current?.click();
                                        }, 0); // Can increase to 50ms if needed
                                    }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--mage" width="20px" height="20px" viewBox="0 0 24 24">
                                        <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M17.928 19.634h2.138a1.165 1.165 0 0 0 1.116-1.555a6.85 6.85 0 0 0-6.117-3.95m0-2.759a3.664 3.664 0 0 0 3.665-3.664a3.664 3.664 0 0 0-3.665-3.674m-1.04 16.795a1.908 1.908 0 0 0 1.537-3.035a8.03 8.03 0 0 0-6.222-3.196a8.03 8.03 0 0 0-6.222 3.197a1.909 1.909 0 0 0 1.536 3.034zM9.34 11.485a4.16 4.16 0 0 0 4.15-4.161a4.151 4.151 0 0 0-8.302 0a4.16 4.16 0 0 0 4.151 4.16" />
                                    </svg>
                                    Delivery Boys
                                </button>
                            </div>

                            <div className='mt-2'>
                                <button className={`menu_item ${activeTab === 'Workshoplist' ? 'active_item' : ''}`} onClick={() => { setActiveTab('Workshoplist'); closeBtnRef.current?.click(); }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--icon-park-outline" width="20px" height="20px" viewBox="0 0 48 48"><g fill="none" stroke="currentColor" stroke-width="4"><path stroke-linecap="round" stroke-linejoin="round" d="M42 24V9a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v30a3 3 0 0 0 3 3h15"></path><circle cx="32" cy="32" r="6"></circle><path stroke-linecap="round" stroke-linejoin="round" d="m37 36l5 4M14 16h20m-20 8h8"></path></g></svg>Workshop</button>
                            </div>

                            <div className='mt-2'>
                                <button className={`menu_item ${activeTab === 'Bikestransfer' ? 'active_item' : ''}`} onClick={() => { setActiveTab('Bikestransfer'); closeBtnRef.current?.click(); }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--icon-park-outline" width="20px" height="20px" viewBox="0 0 48 48"><g fill="none" stroke="currentColor" stroke-width="4"><path stroke-linecap="round" stroke-linejoin="round" d="M42 24V9a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v30a3 3 0 0 0 3 3h15"></path><circle cx="32" cy="32" r="6"></circle><path stroke-linecap="round" stroke-linejoin="round" d="m37 36l5 4M14 16h20m-20 8h8"></path></g></svg>Bikes Transfer</button>
                            </div>



                            <div className='mt-2'>
                                <button className={`menu_item ${activeTab === 'Logout' ? '' : ''}`} onClick={handleLogout}>
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--heroicons-outline" width="20px" height="20px" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h7a3 3 0 0 1 3 3v1"></path></svg>
                                    Logout </button>
                            </div>



                        </>
                    )}







                </div>
            </div>

        </div>
    )
}

export default Dashboard 